<!--This is PDF template for pdf download and pdf package not supported classes for styles for inline css added-->
<!doctype html>
<html lang="en">
  <head>
    <title>Print Feedback</title>
  </head>
  <body id="pdf-data" #pdfContent style="width: 100%; max-width: 600px">
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"5%"}'>
          <img
            *ngIf="printData?.logo"
            [src]="printData?.logo"
            alt="Organization Logo"
            style="width: 125px; height: auto; object-fit: contain" />
        </div>

        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ printData?.orgDetail?.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ printData?.orgDetail?.city }}, {{ printData?.orgDetail?.state }},
            {{ printData?.orgDetail?.country }},
            {{ printData?.orgDetail?.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.feedbackDetail?.studentInfo?.studentFirstName || '-' }}
          {{ printData?.feedbackDetail?.studentInfo?.studentLastName || '-' }}
        </div>
        <div style="width: auto"></div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.feedbackDetail?.studentInfo?.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.feedbackDetail?.studentInfo?.studentDateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.orgDetail?.organizationName || '-' }}</b>
          </div>
        </div>
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b>
              {{
                printData?.feedbackDetail?.studentInfo?.studentGender || '-'
              }}</b
            >
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Assessment Period</div>
          <div class="dataValue">
            <b
              >{{
                printData?.feedbackDetail?.studentInfo?.frequencyDays ?? 0
              }}
              days</b
            >
          </div>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <ng-container *ngIf="behaviorSpecificSections.length">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <th
              style="font-size: 16px"
              data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
              <b>Behavior-Specific Summary</b>
            </th>
          </tr>
        </table>

        <ng-container
          *ngFor="
            let behaviorSection of behaviorSpecificSections;
            let i = index
          ">
          <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
            <div data-pdfmake='{"width":175}' class="datalabel">
              Behavior Category :
            </div>
            <div data-pdfmake='{"width":"*"}' class="datalabel">
              <b>{{
                behaviorSection.questions[0].behaviorCategoryName || '-'
              }}</b>
            </div>
          </div>

          <div
            *ngFor="let questionRow of behaviorSection.questions"
            data-pdfmake='{"margin": [0,0,0,7]}'
            data-pdfmake-type="columns">
            <div data-pdfmake='{"width":175}' class="datalabel">
              {{ questionRow.question }} :
            </div>
            <div data-pdfmake='{"width":"*"}' class="datalabel">
              <b>
                <ng-container *ngIf="questionRow.ratingScale">
                  {{ questionRow.ratingScale }}
                  <span *ngIf="questionRow.answerText">
                    - {{ questionRow.answerText }}
                  </span>
                </ng-container>
                <ng-container *ngIf="!questionRow.ratingScale">
                  {{ questionRow.answerText || '-' }}
                </ng-container>
              </b>
            </div>
          </div>

          <ng-container
            *ngIf="getBehaviorGraphImages(behaviorSection.behaviorId).length">
            <div data-pdfmake='{"width":"*"}'>
              <div
                *ngFor="
                  let imgSrc of getBehaviorGraphImages(
                    behaviorSection.behaviorId
                  );
                  let j = index
                ">
                <img
                  data-pdfmake='{"width":552}'
                  [src]="imgSrc"
                  [alt]="'Chart_' + behaviorSection.behaviorId + '_' + j"
                  class="chartImage" />
              </div>
            </div>
          </ng-container>
          <hr
            data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
          <div
            *ngIf="i < behaviorSpecificSections.length - 1"
            data-pdfmake='{"pageBreak":"after"}'></div>
        </ng-container>
      </ng-container>

      <table
        data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
        <tr>
          <th
            style="font-size: 16px"
            data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
            <b>Overall Scores</b>
          </th>
        </tr>
      </table>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          General behavior rating :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.generalBehaviorRating
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Behavior-specific score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.behaviorSpecificScore
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Intervention & support score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.interventionSupportScore
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Stakeholder score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{ printData?.feedbackDetail?.overallScores?.stakeholderScore }}
          </b>
        </div>
      </div>
      <div
        data-pdfmake='{"margin": [0,0,0,7]}'
        data-pdfmake-type="columns"
        *ngIf="
          printData?.feedbackDetail?.selfAssessmentScores &&
          printData?.feedbackDetail?.selfAssessmentScores?.length &&
          printData?.feedbackDetail?.selfAssessmentScores?.[0]
        ">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Teacher self-assessment scores :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.selfAssessmentScores?.[0]
                ?.overallScore || '-'
            }}
          </b>
        </div>
      </div>
      <div
        data-pdfmake='{"margin": [0,0,0,7]}'
        data-pdfmake-type="columns"
        *ngIf="
          printData?.feedbackDetail?.selfAssessmentScores &&
          printData?.feedbackDetail?.selfAssessmentScores?.length &&
          printData?.feedbackDetail?.selfAssessmentScores?.[1]
        ">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Student-assessment scores:
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.selfAssessmentScores?.[1]
                ?.overallScore || '-'
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Overall behavior score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ printData?.feedbackDetail?.overallScores?.overallScore }} </b>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <table
        data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
        <tr>
          <th
            style="font-size: 16px"
            data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
            <b>Support Recommendations</b>
          </th>
        </tr>
      </table>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Level of support :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.levelOfSupport || '-'
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Recommendation based on score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{ printData?.feedbackDetail?.overallScores?.supportText || '-' }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Re-evaluation Flag :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.reEvaluationFlag
                ? 'Yes'
                : 'No'
            }}
          </b>
        </div>
      </div>
      <div
        data-pdfmake='{"margin": [0,0,0,7]}'
        data-pdfmake-type="columns"
        *ngIf="printData?.feedbackDetail?.overallScores?.reEvaluationFlag">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Re-evaluation Recommendation :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores
                ?.reEvaluationDefaultText || '-'
            }}
          </b>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <ng-container
        *ngIf="
          printData?.feedbackDetail?.interventionAndSupportFeedbacks?.length
        ">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <th
              style="font-size: 16px"
              data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
              <b>Intervention Review</b>
            </th>
          </tr>
        </table>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Requested changes to plan :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.interventionAndSupportFeedbacks?.[0]
                  ?.ratingScale === 5
                  ? 'No modifications requested'
                  : printData?.feedbackDetail
                      ?.interventionAndSupportFeedbacks?.[0]?.answerText
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Additional supports requested :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.interventionAndSupportFeedbacks?.[1]
                  ?.ratingScale === 5
                  ? 'No modifications requested'
                  : printData?.feedbackDetail
                      ?.interventionAndSupportFeedbacks?.[1]?.answerText
              }}
            </b>
          </div>
        </div>
      </ng-container>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <ng-container *ngIf="printData?.feedbackDetail?.adminNotes?.length">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <th
              style="font-size: 16px"
              data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
              <b>Admin Notes</b>
            </th>
          </tr>
        </table>
        <div *ngFor="let note of printData?.feedbackDetail?.adminNotes">
          <table
            data-pdfmake='{"widths": ["*"], "heights": 10,"dontBreakRows": true, "layout": { "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
            <thead>
              <tr>
                <th style="display: none">Note</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  class="font10"
                  data-pdfmake='{"fillColor": "#F9FAFB","padding": [0,3,0,3]}'>
                  <span
                    style="font-size: 14px; margin: 0 0 4px 0; color: #101828"
                    >{{ note.comment }}</span
                  >
                  <br />
                  <span class="datalabel"> - {{ note.userName }} </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </body>
</html>
